<div class="flex h-full min-h-0 w-full flex-col gap-2">

  <!-- Realtor source link — always visible at top, primary CTA -->
  @if (realtorInfo(); as realtor) {
    @if (realtor.darkBg) {
      <a
        [href]="listing().source_url"
        target="_blank"
        rel="noopener noreferrer"
        class="flex shrink-0 items-center justify-between rounded-xs bg-grey-120 px-sm py-2xs transition-opacity hover:opacity-75"
      >
        <img [src]="realtor.logo" alt="Δείτε το ακίνητο" class="h-6 w-auto object-contain" />
        <span class="font-body text-2xs font-semibold text-white">Δείτε το ακίνητο →</span>
      </a>
    } @else {
      <a
        [href]="listing().source_url"
        target="_blank"
        rel="noopener noreferrer"
        class="flex shrink-0 items-center justify-between rounded-xs border border-grey-40 bg-white px-sm py-2xs transition-colors hover:border-grey-80"
      >
        <img [src]="realtor.logo" alt="Δείτε το ακίνητο" class="h-6 w-auto object-contain" />
        <span class="font-body text-2xs font-semibold text-grey-90">Δείτε το ακίνητο →</span>
      </a>
    }
  }

  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      <h3 class="text-md font-semibold leading-normal text-gray-900">
        {{ listing().price }}
      </h3>
      <p class="pt-0.5 text-sm text-gray-500">
        {{ listing().property_type }} • {{ listing().size }}
      </p>
    </div>
    <span
      class="rounded-full bg-brand-100 px-2 py-0.5 text-xs font-medium text-brand-800 shadow-sm"
    >
      {{ listing().listing_type }}
    </span>
  </div>

  <p class="flex min-w-0 items-center text-sm text-gray-600">
    <svg
      class="mr-1 h-4 w-4 shrink-0"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      ></path>
      <path
        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      ></path>
    </svg>
    <span class="truncate">{{ listing().address }}</span>
  </p>

  <div class="flex items-center justify-between text-xs text-gray-500">
    <div class="flex gap-2">
      <span>{{ subtitleDetails() }}</span>
    </div>
  </div>

  <div class="relative">
    <div
      #featuresScroller
      class="cursor-grab select-none overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [touch-action:pan-y] active:cursor-grabbing [&::-webkit-scrollbar]:hidden"
      (lostpointercapture)="onFeaturesPointerUp($event)"
      (pointercancel)="onFeaturesPointerUp($event)"
      (pointerdown)="onFeaturesPointerDown($event)"
      (pointermove)="onFeaturesPointerMove($event)"
      (pointerup)="onFeaturesPointerUp($event)"
      (scroll)="updateFeatureScrollState()"
    >
      @if (visibleFeatures()) {
        <div class="inline-flex w-max gap-2">
          @for (feature of visibleFeatures(); track $index) {
            <span
              class="text-nowrap rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-700 shadow-sm"
            >
              {{ feature }}
            </span>
          }
        </div>
      }
    </div>

    @if (showLeftFade()) {
      <div
        class="pointer-events-none absolute bottom-0 left-0 top-0 w-16 bg-gradient-to-r from-white to-transparent"
      ></div>
    }

    @if (showRightFade()) {
      <div
        class="pointer-events-none absolute bottom-0 right-0 top-0 w-16 bg-gradient-to-l from-white to-transparent"
      ></div>
    }
  </div>

  <div class="max-h-[60px]">
    <p
      class="overflow-hidden text-sm text-gray-700 [-webkit-box-orient:vertical] [display:-webkit-box]"
      [style.-webkit-line-clamp]="3"
    >
      {{ listing().description }}
    </p>
  </div>

</div>
